import React, { useMemo } from 'react';

import RestoreIcon from '@mui/icons-material/Restore';
import { Box, IconButton, Tooltip } from '@mui/material';
import { DataGridPro, GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';

import { IAwsJob } from '~/services/AwsJobsService';

import { IActions } from './types';

interface Props {
  data: Array<IAwsJob>;
  openModal: (name: string, action: IActions) => void;
}

export default function JobsTable({ data, openModal }: Props) {
  const columns: Array<GridColDef> = useMemo(
    () => [
      {
        field: 'name',
        headerName: 'Name',
        disableColumnMenu: true,
        flex: 1,
        sortable: false,
        display: 'flex',
      },
      {
        field: 'info[active]',
        headerName: 'Active Jobs',
        disableColumnMenu: true,
        flex: 1,
        sortable: false,
        display: 'flex',
        valueGetter: (_value, row) => row.info.active,
      },
      {
        field: 'info[delayed]',
        headerName: 'Delayed Jobs',
        disableColumnMenu: true,
        flex: 1,
        sortable: false,
        display: 'flex',
        valueGetter: (_value, row) => row.info.delayed,
      },
      {
        field: 'info[failed]',
        headerName: 'Failed Jobs',
        disableColumnMenu: true,
        flex: 1,
        sortable: false,
        display: 'flex',
        valueGetter: (_value, row) => row.info.failed,
      },
      {
        field: 'info[count]',
        headerName: 'Total Jobs',
        disableColumnMenu: true,
        flex: 1,
        sortable: false,
        display: 'flex',
        valueGetter: (_value, row) => row.info.count,
      },
      {
        field: 'actions',
        headerName: 'Actions',
        disableColumnMenu: true,
        flex: 1,
        sortable: false,
        display: 'flex',
        renderCell: ({ row }: GridRenderCellParams<IAwsJob>) => (
          <Box height={40}>
            {row.info.failed > 0 && (
              <Tooltip title="Restore Failed Jobs">
                <IconButton onClick={() => openModal(row.name, 'restore')}>
                  <RestoreIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        ),
      },
    ],
    [openModal],
  );

  return (
    <>
      <DataGridPro
        columns={columns}
        disableRowSelectionOnClick
        getRowHeight={() => 'auto'}
        getRowId={(row) => row.name}
        rows={data ?? []}
        pagination={false}
        rowCount={data.length}
        density="compact"
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
      />
    </>
  );
}
